import { configureStore } from '@reduxjs/toolkit';
import authSlice from './reducers/authSlice';
import uiSlice from './reducers/uiSlice';

const store = configureStore({
  reducer: {
    auth: authSlice,
    ui: uiSlice,
  },
});

export default store;
